import { Form } from './Form/Form'
import { Root } from './Root/Root'
import { Header } from './Header/Header'
import { MobileHeader } from './Header/MobileHeader'

export const Wizard = {
  Root,
  Header,
  MobileHeader,
  Form,
}
